export default __webpack_public_path__ + "static/media/MountainGladeMap.489e28f3.jpg";